var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-card',[_c('strong',[_vm._v("Gerenciador de certificado: ")]),(_vm.isPkiInstalled)?_c('span',[_vm._v("Instalado")]):_c('rkm-button',{attrs:{"color":"primary"},on:{"click":_vm.redirectToInstallPage}},[_vm._v(" Instalar ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }